module.exports = __webpack_public_path__ + "media/bootstrap-icons/mailbox-91c6d904.svg";